"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListItemMenu = void 0;
var react_1 = __importDefault(require("react"));
var slate_react_1 = require("slate-react");
var tokens_1 = require("@qwilr/kaleidoscope/tokens");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var styles = __importStar(require("./MenuStyles.css"));
var ListItemMenu = function (_a) {
    var filteredButtonConfigs = _a.filteredButtonConfigs, onToolbarEvent = _a.onToolbarEvent, onFocusChange = _a.onFocusChange;
    var editor = (0, slate_react_1.useSlate)();
    var bulletList = filteredButtonConfigs.find(function (_a) {
        var type = _a.type, data = _a.data;
        return type === "listItem" && (data === null || data === void 0 ? void 0 : data["listType"]) === "bullet";
    });
    var numberList = filteredButtonConfigs.find(function (_a) {
        var type = _a.type, data = _a.data;
        return type === "listItem" && (data === null || data === void 0 ? void 0 : data["listType"]) === "number";
    });
    if (!bulletList && !numberList) {
        return null;
    }
    return (react_1.default.createElement(kaleidoscope_1.ToolbarPopover, { className: tokens_1.darkTheme, size: kaleidoscope_1.PopoverSize.Auto, padding: "none", button: function (buttonProps) { return react_1.default.createElement(kaleidoscope_1.ToolbarButton, __assign({}, buttonProps, { icon: react_1.default.createElement(icons_1.ListBullet, null) })); } },
        react_1.default.createElement("div", { onFocus: function (e) { return onFocusChange(e, "listItemMenu", true); }, onBlur: function (e) { return onFocusChange(e, "listItemMenu", false); } },
            react_1.default.createElement(kaleidoscope_1.Stack, { padding: "xxs", gap: "xxs" }, [bulletList, numberList].map(function (buttonConfig, index) {
                if (!buttonConfig)
                    return null;
                var eventData = __assign({ button: buttonConfig.type }, buttonConfig.data);
                var isActive = buttonConfig.isActive(editor, { contextualStylesShowing: false });
                return (react_1.default.createElement(kaleidoscope_1.Button, { className: styles.menuOptionButton, key: index, type: kaleidoscope_1.ButtonType.Tertiary, width: "full", onClick: function () { return onToolbarEvent(eventData); }, "aria-pressed": isActive },
                    buttonConfig.content,
                    getDisplayName(buttonConfig)));
            })))));
};
exports.ListItemMenu = ListItemMenu;
function getDisplayName(buttonConfig) {
    var _a;
    var listType = (_a = buttonConfig.data) === null || _a === void 0 ? void 0 : _a["listType"];
    if (listType === "bullet")
        return "Bullet";
    if (listType === "number")
        return "Number";
    return "";
}
